import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {SuppressionReasonDropdownComponent} from '../../components/DomainData/SuppressionReasonDropdown.component';
import {VendPackageLineItemGridComponent} from '../../components/Grids/VendPackageLineItemGrid.component';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-suppress-status',
  templateUrl: './SuppressStatus.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => SuppressStatusComponent)}]
})
export class SuppressStatusComponent extends BaseControlGroupComponent {

    public suppressStatusForm: FormGroup;
    suppressInfo: ent.SuppressInfo = new ent.SuppressInfo();

    @Input() public showVendPackageLineItems: boolean;
    @Input() public showSuppressCustomer: boolean;
    @Input() public showSuppressionReason: boolean;
    @Input() public showUnSuppressCustomer: boolean; 
    @Input() public showOwnershipChange: boolean; 
    @Input() public showOrderMethod: boolean;

    @Input() public requireSuppressionReason: boolean;

  
    @ViewChild(SuppressionReasonDropdownComponent) public suppressionReasonDropdown: SuppressionReasonDropdownComponent;
    @ViewChild(VendPackageLineItemGridComponent) public vendPackageLineItemGrid: VendPackageLineItemGridComponent;
    
    setDates(){}

    setRequestInfo(request: ent.Request){
        this.suppressInfo = request.SuppressInfo;
        if (request.VendPackageLineItems && this.vendPackageLineItemGrid){
            this.vendPackageLineItemGrid.lineItems = request.VendPackageLineItems;
        }
    }

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'suppressCustomer' : '',
          'suppressionReason' : '',
          'unSuppressCustomer' : '',
          'ownershipChange' : '',
          'orderMethod' : '',
          'hidOrderMethod' : ''
        };
        
        this.suppressStatusForm = fb.group(group);

    }


    ngOnInit(): void {
        if(this.requireSuppressionReason) {
            this.suppressStatusForm.controls['suppressionReason'].setValidators(Validators.required);
        }
    }

    suppressionReasonChange(event: any){
        this.suppressInfo.SuppressionReasonID = event;
    }

    orderMethodSelected(){
        var val = true;
        var form = this.suppressStatusForm;
        if (form.controls.orderMethod.errors && form.controls.hidOrderMethod.errors){
            if (form.controls.orderMethod.errors.invalid && form.controls.hidOrderMethod.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    orderMethodChange(event: any){
        this.suppressInfo.OrderMethodID = event;
    }

}